module.exports = "icons/outdoor-light.svg";